export default __webpack_public_path__ + "static/proto_board-98a498034cd043738e7210ed9c028a77.jpg";